import React, { useState, useEffect } from "react";
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import axios from "axios";
import { baseurladdress } from "../baseurl"

import Select from 'react-select';
import $ from 'jquery';

import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

export default function ShiftApproval() {
    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");
    const [selectbranch, setselectbranch] = useState([]);
    const [selectedBranchId, setSelectedBranchId] = useState("");
    const [selectdept, setselectdept] = useState([]);
    const [selecteddeptId, setSelectedDeptId] = useState("");
    const [employees, setEmployees] = useState([]);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [data, setShiftapproversData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});



    const Swal = require('sweetalert2')
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 1800,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    //get branches name
    useEffect(() => {
        const getbranchbyname = () => {
            axios.get(baseurladdress + `getallbranchesbyname`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
                .then(res => {
                    const data = res.data.response;
                    setselectbranch(data);
                }).catch(error => {
                    alert(error);
                });
        };
        getbranchbyname();
    }, []);


    //get departments based on branchid
    useEffect(() => {
        if (!selectedBranchId) {
            setselectdept([]);
            setSelectedDeptId('');
            setEmployees([]);
            return;
        }

        axios.get(baseurladdress + `getdeptsbybranch/${selectedBranchId}`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response || [];
                setselectdept(data);
                setSelectedDeptId('');
            })
            .catch(error => {
                alert(error);
                setselectdept([]);
            });
    }, [selectedBranchId]);


    //getemployeenames based on search
    const fetchEmployees = (searchTerm) => {
        let url = baseurladdress + `getemployeesbybranchdept/${selectedBranchId}`;
        if (selecteddeptId) {
            url += `/${selecteddeptId}`;
        }
        url += `?search=${encodeURIComponent(searchTerm)}`;

        axios
            .get(url, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                const data = res.data.response || [];
                const options = data.map((item) => ({
                    value: item.staff_id,
                    label: item.staff_name,
                    email: item.staff_email
                }));
                setEmployees(options);
            })
            .catch((error) => {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: error.message || "Failed to load employees!",
                });
                setEmployees([]);
            });
    };

    // useEffect(() => {
    //     if (!selectedBranchId || !search || search.trim() === "") {
    //         setEmployees([]);
    //         return;
    //     }
    //     fetchEmployees(search);
    // }, [selectedBranchId, selecteddeptId, search]);


    // add shift approvers
    const handleAddApprovers = () => {
        const selectedBranch = selectbranch.find(branch => String(branch.branch_id) === String(selectedBranchId));

        console.log("Selected Branch:", selectedBranch);
        const data = {
            dept_crtdby: accessuserid,
            branch_id: selectedBranchId,
            branch_name: selectedBranch?.branch_name || "",
            dept_id: selecteddeptId,
            employees: (Array.isArray(selectedEmployees) ? selectedEmployees : [selectedEmployees]).map(emp => ({
                staff_id: emp.value,
                staff_name: emp.label,
                staff_email: emp.email
            }))

        };

        fetch(baseurladdress + `addshiftapprovers`, {
            method: "POST",
            headers: {
                Accept: "application/form-data",
                "Content-Type": "application/json",
                Authorization: `Bearer ${accesstoken}`,
            },
            body: JSON.stringify(data),
        })
            .then((res) => res.json())
            .then((result) => {
                if (result["status"] === "success") {
                    setSelectedBranchId("");
                    setSelectedDeptId("");
                    setSelectedEmployees([]);
                    setInputValue("");
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1200,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })
                    Toast.fire({
                        icon: 'success',
                        title: 'Shift approvers added successfully'
                    })
                    GetAllShiftapprovers();

                } else {
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1000,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })
                    Toast.fire({
                        icon: 'error',
                        title: 'Something went wrong'
                    });
                }
            });
    };


    // getshiftapprovers
    const GetAllShiftapprovers = () => {
        axios
            .get(baseurladdress + `getallshiftapprovers`, {
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                },
            })
            .then(res => {
                const datas = res.data.response;
                console.log("itemss" + datas);
                const data = datas.map((item, index) => (
                    <tr style={{ textAlign: "left" }}
                    >
                        <td>{index + 1}</td>
                        <td>{item.shap_staffname}</td>
                        <td>{item.shap_staffemail}</td>
                        <td>
                            <a
                                className="inline-block"
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedRow(item);
                                    setIsModalOpen(true);
                                }}
                            >
                                <i className="text-primary fa fa-edit"></i>
                            </a>
                        </td>
                        <td style={{ textAlign: "left" }}>
                            <a

                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    deleteShiftApprover(item.shap_id);
                                }}
                            >
                                <i className="text-danger fa fa-trash"></i>
                            </a>
                        </td>


                    </tr>
                ));

                setShiftapproversData(data)
            })
            .catch(error => {
                setShiftapproversData([]);
                Toast.fire({
                    icon: 'error',
                    title: 'No shift approvers'
                })
            })
    }

    useEffect(() => {
        GetAllShiftapprovers();
    }, []);


    // update shift approvers
    const handleUpdateApprover = (event) => {
        event.preventDefault();

        var data = {
            shap_staffname: selectedRow.shap_staffname,
            shap_staffemail: selectedRow.shap_staffemail,
            shap_updatedby: accessuserid,
            shap_id: selectedRow.shap_id,
        };

        fetch(baseurladdress + `updateshiftapprover/` + selectedRow.shap_id, {
            method: "POST",
            headers: {
                Accept: "application/form-data",
                "Content-Type": "application/json",
                Authorization: `Bearer ${accesstoken}`,
            },
            body: JSON.stringify(data),
        })
            .then((res) => res.json())
            .then((result) => {
                if (result["status"] === "updated") {
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1200,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })
                    Toast.fire({
                        icon: 'success',
                        title: 'Edited Successfully'
                    });
                    setIsModalOpen(false);
                    GetAllShiftapprovers();
                } else {
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 500,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    });
                    Toast.fire({
                        icon: 'error',
                        title: 'Something went wrong'
                    });
                }
            })
            .catch((error) => {
                console.error('Error updating shift approver:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Network Error',
                    text: 'Please try again later',
                });
            });
    };


    // delete shift approver
    const deleteShiftApprover = (shap_id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'Do you really want to delete this shift approver?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
        }).then((result) => {
            if (result.isConfirmed) {
                axios
                    .post(baseurladdress + `deleteshiftapprover/` + shap_id, {}, {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`,
                        },
                    })
                    .then((res) => {
                        Toast.fire({
                            icon: 'success',
                            title: 'Shift approver deleted successfully'
                        });
                        GetAllShiftapprovers(); // Refresh data
                    })
                    .catch((error) => {
                        Toast.fire({
                            icon: 'error',
                            title: 'Failed to delete shift approver'
                        });
                    });
            }
        });


    };


$(function () {
    setTimeout(function () {
      $('#shiftaprvllist').DataTable();
    }, 1000);
  });

    return (
        <>
            <Topnavbar />,
            <Sidennav />,
            <div class="content-wrap" style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                <div className="container-fluid">
                    <form onSubmit={(e) => e.preventDefault()} className="container-fluid mt-3">
                        <div className="row gy-3">

                            <div className="col-12 col-md-3">
                                <select
                                    className="form-control"
                                    value={selectedBranchId}
                                    onChange={(e) => {
                                        const branchId = e.target.value;
                                        setSelectedBranchId(branchId);
                                        setSelectedDeptId("");
                                        setInputValue("");
                                        setSelectedEmployees([]);
                                    }}
                                >
                                    <option value="">Select Branch</option>
                                    {selectbranch.map((branch) => (
                                        <option key={branch.branch_id} value={branch.branch_id}>
                                            {branch.branch_name}
                                        </option>
                                    ))}
                                </select>
                            </div>


                            <div className="col-12 col-md-3">
                                <select
                                    className="form-control"
                                    value={selecteddeptId}
                                    onChange={(e) => {
                                        const deptId = e.target.value;
                                        setSelectedDeptId(deptId);
                                        setInputValue("");
                                        setSelectedEmployees([]);
                                    }}
                                >
                                    <option value="">Select Department</option>
                                    {selectdept.map((dept) => (
                                        <option key={dept.dept_id} value={dept.dept_id}>
                                            {dept.dept_name}
                                        </option>
                                    ))}
                                </select>
                            </div>


                            <div className="col-12 col-md-3">
                                <Select
                                    options={employees.filter(
                                        (emp) => !selectedEmployees.some((sel) => sel.value === emp.value)
                                    )}
                                    isMulti
                                    closeMenuOnSelect={false}
                                    value={selectedEmployees}
                                    inputValue={inputValue}
                                    onInputChange={(newValue, actionMeta) => {
                                        if (actionMeta.action === "input-change") {
                                            setInputValue(newValue);
                                            if (newValue.trim() === "") {
                                                setEmployees([]);
                                            } else {
                                                fetchEmployees(newValue);
                                            }
                                        } else if (actionMeta.action === "menu-close") {
                                            setEmployees([]);
                                        }
                                    }}
                                    onChange={(selected) => {
                                        setSelectedEmployees(selected || []);
                                        setInputValue("");
                                    }}
                                    placeholder="Search Employees"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                />
                            </div>


                            <div className="col-12 col-md-3 d-flex align-items-center">
                                <button
                                    type="button"
                                    className="btn btn-outline-primary btn-sm d-flex align-items-center justify-content-center"
                                    onClick={() => {
                                        // setShowSearch(!showSearch);
                                        handleAddApprovers();
                                    }}>
                                    <i className="fa fa-plus me-1"></i> Add Shift Approver
                                </button>
                            </div>
                        </div>
                    </form>

                    <div className="col-sm-12 mt-3">
                        <h6>Shift Approvers</h6>
                        <div className="table-responsive">
                            <table className="table table-bordered" id="shiftaprvllist">
                                <thead>
                                    <tr
                                        style={{
                                            borderTop: "1px solid #bbb",
                                            borderBottom: "2px solid #bbb",
                                            textAlign: "left",
                                        }}
                                    >
                                        <th>Sl.No</th>
                                        <th>Staff</th>
                                        <th>Email</th>
                                        <th>Edit</th>
                                        <th style={{
                                            textAlign: "left",
                                        }}>Delete</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {data}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                {isModalOpen && (
                    <div className="modal show fade d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Edit Shift Approver</h5>
                                    <button type="button" className="close" onClick={() => setIsModalOpen(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label><b>Staff Name</b></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                style={{ boxShadow: "0 0 8px rgba(0, 0, 0, 0.15)" }}
                                                value={selectedRow.shap_staffname}
                                                onChange={(e) =>
                                                    setSelectedRow({ ...selectedRow, shap_staffname: e.target.value })
                                                }
                                            />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label><b>Email</b></label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                style={{ boxShadow: "0 0 8px rgba(0, 0, 0, 0.15)" }}
                                                value={selectedRow.shap_staffemail}
                                                onChange={(e) =>
                                                    setSelectedRow({ ...selectedRow, shap_staffemail: e.target.value })
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-primary" onClick={handleUpdateApprover}>
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </>
    )
}